export default import.meta.ROLLUP_FILE_URL_7nH$wSdk5KV9ey9k7iGVPw